import Spinner from '@/components/basic/Spinner';
import {useSetCustomBreadcrumb} from '@/hooks/useBreadcrumbs';
import {defaultQueryOptions} from '@/pages/_utils';
import {CanAccess, useShow} from '@refinedev/core';
import {getPriorityInfo, getStatusInfo} from './types';
import {Star, CalendarDays, Flag, Clock, FileText, LucideIcon, BookAIcon} from 'lucide-react';
import React from 'react';
import {cn} from '@/lib/tailwind-utils';
import {Separator} from '@/shadcn_components/ui/separator';
import {Tabs, TabsContent, TabsList, TabsTrigger} from '@/shadcn_components/ui/tabs';
import {useSearchParams} from 'react-router-dom';
import TaskOverview from './components/task-overview';
import DocumentList from '../documents/document-list';
import useMyResourceParams from '@/hooks/refinedev/useMyResourceParams';
import ConversationView from '../conversations/conversation-view';
import TaskListInTask from './task-list-in-task';

const thisResource = 'tasks';

const TaskShow = () => {
  const resParams = useMyResourceParams();
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'overview';

  const handleTabChange = (tab: string) => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('tab', tab);
    window.history.replaceState({}, '', currentUrl.toString());
  };

  const {query} = useShow({
    queryOptions: {
      ...defaultQueryOptions,
    },
    errorNotification: false,
    meta: {
      with: ['project', 'members', 'created_by'],
    },
  });

  const {data, isFetching, error, isError} = query;
  const record = data?.data;

  useSetCustomBreadcrumb(query?.data?.data?.name);
  if (!resParams.id) return <p>Đường dẫn không hợp lệ</p>;

  if (isFetching) {
    return <Spinner />;
  }

  if (isError) {
    return <p>{error?.data?.message || 'Đã có lỗi xảy ra'}</p>;
  }

  if (!record) {
    return <p>Không tìm thấy thông tin</p>;
  }

  return (
    <div className="px-2 h-full">
      <div className="flex flex-row h-16">
        <div className="flex flex-col">
          <p className="text-lg font-semibold">{record.name}</p>
          <p className="text-xs">{record.description}</p>
        </div>
      </div>

      <Tabs
        defaultValue={defaultTab}
        onValueChange={handleTabChange}
        className="h-[calc(100%-4rem)]">
        <TabsList className="flex gap-x-4 h-12">
          <TabsTrigger value="overview">Tổng quan</TabsTrigger>
          <TabsTrigger value="tasks">Công việc con</TabsTrigger>
          {/* <CanAccess resource="documents" action="list"> */}
          <TabsTrigger value="documents">Tài liệu</TabsTrigger>
          {/* </CanAccess> */}
          {/* <CanAccess resource="conversations" action="list">
            <TabsTrigger value="conversations">Trao đổi</TabsTrigger>
          </CanAccess> */}
        </TabsList>

        <div className="h-[calc(100%-3rem)]">
          <TabsContent value="overview" forceMount>
            <TaskOverview task={record} />
          </TabsContent>

          <TabsContent value="tasks" forceMount>
            <TaskListInTask parent_task={record} />
          </TabsContent>

          {/* <CanAccess resource="documents" action="list"> */}
          <TabsContent value="documents" forceMount>
            <DocumentList mediable_type="task" mediable_id={resParams.id} />
          </TabsContent>
          {/* </CanAccess> */}

          {/* <CanAccess resource="conversations" action="list">
            <TabsContent value="conversations" forceMount className="h-full">
              <ConversationView owner_type="task" owner_id={resParams.id} />
            </TabsContent>
          </CanAccess> */}
        </div>
      </Tabs>
    </div>
  );
};

// const TaskShowWithPermission = () => {
//   return (
//     <CanAccess
//       resource={thisResource}
//       action="read"
//       fallback={<p>Bạn không có quyền truy cập trang này</p>}>
//       <TaskShow />
//     </CanAccess>
//   );
// };

export default TaskShow;
